__turbopack_context__.v({
  "container": "tf43CW_container",
  "email": "tf43CW_email",
  "fields": "tf43CW_fields",
  "message": "tf43CW_message",
  "submit": "tf43CW_submit",
});
